import React, { useState } from "react";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import SendEmailModalBase from "./SendEmailModalBase";
import SendThongBaoPhiPrintBtn from "./SendThongBaoPhiPrintBtn";
import { QRModalContent } from "../tao-bien-lai";
import Modal from "../../../components/ui/modal";
import { Button } from "../../buttons";

type SendThongBaoPhiModalProps = {
    onClose: () => void,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh_id: number,
    printDisabled?: boolean,
    buttonText?: string
}

const SendThongBaoPhiModal: React.FC<SendThongBaoPhiModalProps> = (props) => {
    const [isShowQrModal, setIsShowQrModal] = useState<boolean>(false);

    return (
        <>
            <SendEmailModalBase
                onClose={props.onClose}
                sf_mucphaithu={props.sf_mucphaithu}
                ts_hocsinh_id={props.ts_hocsinh_id}
                buttonText={props.buttonText}
                title="Gửi thông báo phí đến PHHS"
                sendButtonText="Gửi thông báo phí"
                successMessage="Đã gửi email thông báo phí"
                failedMessage="Không gửi được thông báo phí"
                loadEmailContent={bienLaiThuApi.get_thongbaophi_email_content}
                sendEmail={bienLaiThuApi.send_thongbaophi}
                renderPrintButton={() => (
                    <>
                        {!props.sf_mucphaithu.so_chung_tu.includes("RV") && (
                            <SendThongBaoPhiPrintBtn
                                disabled={props.printDisabled ?? false}
                                sf_mucphaithu={props.sf_mucphaithu}
                                buttonText="In thông báo phí"
                            />
                        )}
                        <Button
                            type="normal"
                            text="Mã QR Thanh toán"
                            icon="fa fa-qrcode"
                            isDisabled={false}
                            onClick={() => setIsShowQrModal(true)}
                        />
                    </>
                )}
            />

            {isShowQrModal && (
                <Modal
                    title="Mã QR Thanh toán BIDV"
                    width="xlarge"
                    isOpen={isShowQrModal}
                    onClose={() => setIsShowQrModal(false)}
                >
                    <QRModalContent
                        sf_mucphaithu={props.sf_mucphaithu}
                        onClose={() => setIsShowQrModal(false)}
                    />
                </Modal>
            )}
        </>
    );
};

export default SendThongBaoPhiModal;
